import { render } from "./AiChatPanelResizer.vue?vue&type=template&id=67852b5a&ts=true"
import script from "./AiChatPanelResizer.vue?vue&type=script&lang=ts"
export * from "./AiChatPanelResizer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__